<template>
  <Posts :object="object" :params="params" />
</template>

<script>
import {defineComponent} from "vue"
import Posts from "@/modules/post/pages/posts/components/posts/Posts"
import Drafts from "@/modules/post/pages/posts/services/Drafts"

export default defineComponent({
  name: "NotesDrafts",
  components: {
    Posts
  },
  setup() {
    let object = new Drafts()

    let params = {
      title: "Все черновики заметок",
      h1: "Черновики заметок",
      page: "notes_drafts",
      type_ids: [5],
      channel_id: getChannelId(),
    }

    function getChannelId() {
      return 1
    }

    return {
      object,
      params,
    }
  }
})
</script>

<style scoped>

</style>
